import './AcceptInvite.css';

import { Bendie, BendieAnimation, Motion } from 'components/bendies/Bendie';
import { Button } from 'components/core/button';
import { Text } from 'components/core/text';
import Logo from 'public/assets/logo.svg';

export default function SessionErrorPage() {
  const handleOnClick = () => {
    // in theory, at this point the user has already gotten a keycloak error
    // and the error handler has already cleared out localstorage
    // This component should be outside of the AuthProvider, meaning
    // keycloak has been unmounted. We *should* be able to direct the user back
    // to the home page and get a fresh anonymous session from keycloak, which *should*
    // direct the user back to login

    // just in case, clear out the storage one last time
    window.localStorage.clear();

    window.location.href = '/';
  };

  return (
    <div className="AcceptInvitePage grid-12 m-grid-6 bendie-grid">
      <div className="span-6 left-panel">
        <div className="left-panel-inner sad-gradient centered-column pt-16-m">
          <div className="bendie-wrapper">
            <BendieAnimation bendie={Bendie.Gus} motion={Motion.Scratch} />
          </div>
        </div>
      </div>
      <div className="span-6 right-panel centered-column">
        <img className="content-logo" src={Logo} />
        <Text variant="heading3" style={{ paddingBottom: 8 }}>
          We&apos;re sorry
        </Text>
        <Text block variant="text4" style={{ textAlign: 'center' }}>
          <p>
            Something went wrong with your session. Please try logging in again.
          </p>
        </Text>
        <div className="submit-wrapper" style={{ paddingTop: '2em' }}>
          <Button type="button" onClick={handleOnClick}>
            Login
          </Button>
        </div>
      </div>
    </div>
  );
}
